import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import "./Empdashboard.css";
import Uppercase from "../../admin/components/Uppercase";
import { useYearContext } from "../../admin/components/YearContext";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Empdashboard() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();
  const navigate = useNavigate();
  const[empname,setEmpname] = useState("");
  const [username, setUsername] = useState("");
  // useEffect(() => {
  //   const token = Cookies.get("token");

  //   if (!token) {
  //     navigate("/login");
  //   } else {
  //     const decoded = jwtDecode(token);
  //     setEmail(decoded.email);
  //   }
    
  // }, []);


  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email);

      if (decoded.role !== "employee") {
        navigate("/login");
      }
    }
    fetchUsername();
  }, [token, navigate]);

  const fetchUsername = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/getemployeeusername", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        setEmpname(response.data.result[0].userName);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const [data, setData] = useState({
    team: [
      { title: "Total Assigned", value: "0" },
      { title: "Paid", value: "0" },
      { title: "Pending", value: "0" },
    ],
    clients: [
      { title: "New Clients", value: "0" },
      { title: "Existing Clients", value: "0" },
      { title: "Documents Pending", value: "0" },
      { title: "Voice Mail", value: "0" },
      { title: "Preparation Pending", value: "0" },
      { title: "Paid Clients", value: "0" },
      { title: "Payment Pending Clients", value: "0" },
      { title: "Pending Amount", value: "0" },
      { title: "Partial Payment Clients", value: "0" },
      { title: "Partial Amount", value: "0" },
      { title: "Completed", value: "0" },
    ],
    leads: [
      { title: "Total Leads", value: "0" },
      { title: "Registered", value: "0" },
      { title: "Callback", value: "0" },
      { title: "Intrested", value: "0" },
      { title: "Not Intrested", value: "0" },
      { title: "Duplicate", value: "0" },
      { title: "Voice mails", value: "0" },
      { title: "Citizens", value: "0" },
      { title: "Service Emails Sent", value: "0" },
    ],
    referrals: [
      { title: "Referrals Received", value: "0" },
      { title: "Successful Referrals", value: "0" },
      { title: "Referral Conversion Rate", value: "0" },
    ],
  });

  //stats
  const [empTotalassigned, setempTotalassigned] = useState("");
  useEffect(() => {
    axios
      .get(` https://api.easytaxexperts.com/get/empdetails/${username}`)
      .then((response) => {
        setempTotalassigned(response.data[0].targetAssigned);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [username]);

  const [invoices, setInvoices] = useState([]);

  const fetchempinvoices = async () => {
    try {
      const response = await axios.get(
        ` https://api.easytaxexperts.com/getempinvoices/${username}`
      );
      if (response.data.success) {
        setInvoices(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
      if (error.response) {
        console.log(
          `Error ${error.response.status}: ${error.response.data.message}`
        );
      }
    }
  };

  useEffect(() => {
    if (username) {
      fetchempinvoices();
    }
  }, [username]);

  const filterInvoiceDocuments = invoices.filter((each) => {
    const documentDate = each.InvoiceDate ? each.InvoiceDate : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;
    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  const invoicestatsToCount = ["Paid"];

  useEffect(() => {
    const invoiceamount = filterInvoiceDocuments.reduce((acc, doc) => {
      const normalizedStatus = doc.PaymentStatus;
      if (invoicestatsToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] =
          (acc[normalizedStatus] || 0) + Number(doc.totalBill);
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        team: prevData.team.map((card) => {
          if (card.title === "Total Assigned") {
            return { ...card, value: empTotalassigned };
          }
          if (card.title === "Paid") {
            return { ...card, value: `${invoiceamount.Paid || 0}` };
          }
          if (card.title === "Pending") {
            return {
              ...card,
              value: empTotalassigned - `${invoiceamount.Paid || 0}`,
            };
          }

          return card;
        }),
      };
    });
  }, [filterInvoiceDocuments]);

  //leads

  const [leaddocuments, setleadDocuments] = useState([]);
  const fetchDocuments = async () => {
    try {
      const response = await axios.get(
        ` https://api.easytaxexperts.com/empleads/${username}`
      );
      if (response.data.success) {
        setleadDocuments(response.data.leadsResult);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [username]);

  const filterleadDocuments = leaddocuments.filter((doc) => {
    const documentDate = doc.created_at ? doc.created_at.substring(0, 10) : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;

    return documentDate >= startDate && documentDate <= endDate;
  });

  const statusesToCount = [
    "Voicemail",
    "Callback",
    "Intrested",
    "NotIntrested",
    "Duplicate",
    "Registered",
  ];

  useEffect(() => {
    const totalRecords = filterleadDocuments.length;
    const countLeadsByStatus = filterleadDocuments.reduce((acc, doc) => {
      const normalizedStatus = doc.status.replace(/\s+/g, "");
      if (statusesToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] = (acc[normalizedStatus] || 0) + 1;
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        leads: prevData.leads.map((card) => {
          if (card.title === "Total Leads") {
            return { ...card, value: totalRecords };
          }
          if (card.title === "Callback") {
            return { ...card, value: `${countLeadsByStatus.Callback || 0}` };
          }
          if (card.title === "Registered") {
            return { ...card, value: `${countLeadsByStatus.Registered || 0}` };
          }
          if (card.title === "Interested") {
            return { ...card, value: `${countLeadsByStatus.Intrested || 0}` };
          }
          if (card.title === "Not Interested") {
            return {
              ...card,
              value: `${countLeadsByStatus.NotIntrested || 0}`,
            };
          }
          if (card.title === "Duplicate") {
            return { ...card, value: `${countLeadsByStatus.Duplicate || 0}` };
          }
          if (card.title === "Voice mails") {
            return { ...card, value: `${countLeadsByStatus.Voicemail || 0}` };
          }
          return card;
        }),
      };
    });
  }, [filterleadDocuments]);

  //clients

  const [clientData, setClientData] = useState([]);

  const fetchClientData = async () => {
    try {
      const response = await axios.get(
        ` https://api.easytaxexperts.com/empdashclients/${username}`
      );
      if (response.data.success) {
        setClientData(response.data.clientsResult);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClientData();
  }, [username]);

  const filterclientDocuments = clientData.filter((doc) => {
    const documentDate = doc.registered_at
      ? doc.registered_at.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;

    return documentDate >= startDate && documentDate <= endDate;
  });

  const clientstatusesToCount = [
    "Documentpending",
    "Voicemail",
    "Preparationpending",
    "Paid",
    "Paymentpending",
    "Partialpayment",
    "Complete",
  ];

  useEffect(() => {
    const totalRecords = filterclientDocuments.length;
    const countClientsByStatus = filterclientDocuments.reduce((acc, doc) => {
      const normalizedStatus = doc.status.replace(/\s+/g, "");
      if (clientstatusesToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] = (acc[normalizedStatus] || 0) + 1;
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        clients: prevData.clients.map((card) => {
          if (card.title === "New Clients") {
            return { ...card, value: totalRecords };
          }
          if (card.title === "Documents Pending") {
            return {
              ...card,
              value: `${countClientsByStatus.Documentpending || 0}`,
            };
          }
          if (card.title === "Voice Mail") {
            return { ...card, value: `${countClientsByStatus.Voicemail || 0}` };
          }
          if (card.title === "Preparation Pending") {
            return {
              ...card,
              value: `${countClientsByStatus.Preparationpending || 0}`,
            };
          }
          if (card.title === "Paid Clients") {
            return {
              ...card,
              value: `${countClientsByStatus.Paid || 0}`,
            };
          }
          if (card.title === "Payment Pending Clients") {
            return {
              ...card,
              value: `${countClientsByStatus.Paymentpending || 0}`,
            };
          }
          if (card.title === "Partial Payment Clients") {
            return {
              ...card,
              value: `${countClientsByStatus.Partialpayment || 0}`,
            };
          }
          if (card.title === "Completed") {
            return { ...card, value: `${countClientsByStatus.Complete || 0}` };
          }
          return card;
        }),
      };
    });
  }, [filterclientDocuments]);

  const [toggle, setToggle] = useState(1);

  function updateToggle(id) {
    setToggle(id);
  }

  //Refferals

  const [referralData, setReferralData] = useState([]);
  const fetchReferrals = async () => {
    try {
      const response = await axios.get(` https://api.easytaxexperts.com/get/empreferrals/${empname}`);
      if (response.data.success) {
        setReferralData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReferrals();
  }, []);



  
  const filterreferralDocuments = referralData.filter((each) => {
    const documentDate = each.DateandTime
      ? each.DateandTime.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });


  useEffect(() => {
    const totalRecords = filterreferralDocuments.length;
    const referralEmails = filterreferralDocuments.map(
      (doc) => doc.ReferralEmail
    );
    const clientEmails = filterclientDocuments.map((doc) => doc.email);

    const successfulReferralsCount = referralEmails.filter((email) =>
      clientEmails.includes(email)
    ).length;

    setData((prevData) => {
      return {
        ...prevData,
        referrals: prevData.referrals.map((card) => {
          if (card.title === "Referrals Received") {
            return { ...card, value: totalRecords };
          }
          if (card.title === "Successful Referrals") {
            return { ...card, value: successfulReferralsCount };
          }
          if (card.title === "Referral Conversion Rate") {
            return {
              ...card,
              value:
                successfulReferralsCount == 0
                  ? "0%"
                  : `${(successfulReferralsCount / totalRecords) * 100}%`,
            };
          }

          return card;
        }),
      };
    });
  }, [filterreferralDocuments]);

  const reversedreferralDocuments = filterreferralDocuments.slice().reverse();

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div className=" py-4">
              <ul className=" d-flex product_links justify-content-center justify-content-lg-start">
                <li
                  className={`col-lg-1 col-md-2 col-sm-4  ${
                    toggle === 1 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(1)}
                >
                  My Stats
                </li>
                <li
                  className={`col-lg-1 col-md-2 col-sm-4 ${
                    toggle === 2 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(2)}
                >
                  Clients
                </li>
                <li
                  className={`col-lg-1 col-md-2 col-sm-4  ${
                    toggle === 3 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(3)}
                >
                  Leads
                </li>
                <li
                  className={`col-lg-1 col-md-2 col-sm-4 ${
                    toggle === 4 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(4)}
                >
                  Referrals
                </li>
              </ul>
            </div>

            <div
              className={
                toggle === 1 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.team.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-5 table-responsive">
                <table className="table table-hover table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th colspan="3" className="text-center">
                        Total Target
                      </th>
                      <th colspan="3" className="text-center">
                        Today Target
                      </th>
                    </tr>
                    <tr>
                      <th>Assigned</th>
                      <th>Achieved</th>
                      <th>Pending</th>
                      <th>Assigned</th>
                      <th>Achieved</th>
                      <th>Pending</th>
                    </tr>
                  </thead>

                  <tbody></tbody>
                </table>
              </div>
            </div>

            <div
              className={
                toggle === 2 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.clients.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className={
                toggle === 3 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.leads.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className={
                toggle === 4 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.referrals.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-5 table-responsive">
                <table className="table table-hover  table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th>S.NO</th>
                      <th>Referral Name</th>
                      <th>Referral Email</th>
                      <th>Referral Phone</th>
                      <th>Referred By</th>
                      <th>Referral Date</th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    {reversedreferralDocuments.map((each, index) => (
                      <tr key={each.id}>
                        <td>{index + 1} </td>
                        <td>{each.ReferralName}</td>
                        <td>{each.ReferralEmail}</td>
                        <td>{each.ReferralPhoneNumber}</td>
                        <td>{each.Clientemail}</td>
                        <td>{each.DateandTime}</td>
                      
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empdashboard;
